import React from "react";
// import { LabelWrapper } from "./Card.styled";
import PropTypes from "prop-types";
import { styled } from "styled-components";

// eslint-disable-next-line no-unused-vars
function ChartlabelALT({
	firstColorId,
	secondColorId,
	thirdColorId,
	fourthColorId,
	fifthColorId,
	sixthColorId,
	firstCaption,
	secondCaption,
	thirdCaption,
	fourthCaption,
	fifthCaption,
	sixthCaption,
	firstAmount,
	secondAmount,
	thirdAmount,
	fourthAmount,
	fifthAmount,
	sixthAmount,
	totalAmount,
	customLabel,
}) {
	//percentage calculator
	const calculatePercentage = (value, total) => {
		if (total === 0) {
			return 0;
		}
		return ((value / total) * 100).toFixed(2);
	};
	return (
		<LabelWrapper
			firstcolor={firstColorId}
			secondcolor={secondColorId}
			thirdcolor={thirdColorId}
			fourthcolor={fourthColorId}
			fifthcolor={fifthColorId}
			sixthcolor={sixthColorId}>
			<section className='firstSection'>
				<div className='firstcolor'></div>
				<div className='firstDetails'>
					<p className='header flex gap-2'>
						<span>{firstCaption}</span>
						<span style={{ fontWeight: "400" }}>({calculatePercentage(firstAmount, totalAmount)}%)</span>
					</p>
					<div>{firstAmount + " " + customLabel}</div>
				</div>
			</section>

			<section className='firstSection'>
				<div className='secondcolor'></div>
				<div className='firstDetails'>
					<p className='header flex gap-2'>
						{secondCaption}
						<span style={{ fontWeight: "400" }}>({calculatePercentage(secondAmount, totalAmount)}%)</span>
					</p>
					<div>{secondAmount + " " + customLabel}</div>
				</div>
			</section>

			{thirdCaption ? (
				<section className='firstSection'>
					<div className='thirdcolor'></div>
					<div className='firstDetails'>
						<p className='header flex gap-2'>
							{thirdCaption}
							<span style={{ fontWeight: "400" }}>({calculatePercentage(thirdAmount, totalAmount)}%)</span>
						</p>
						<div>{thirdAmount + " " + customLabel}</div>
					</div>
				</section>
			) : null}

			{fourthCaption ? (
				<section className='firstSection'>
					<div className='fourthcolor'></div>
					<div className='firstDetails'>
						<p className='header flex gap-2'>
							{fourthCaption}
							<span style={{ fontWeight: "400" }}>({calculatePercentage(fourthAmount, totalAmount)}%)</span>
						</p>
						<div>{fourthAmount + " " + customLabel}</div>
					</div>
				</section>
			) : null}

			{fifthCaption ? (
				<section className='firstSection'>
					<div className='fifthcolor'></div>
					<div className='firstDetails'>
						<p className='header flex gap-2'>
							{fifthCaption}
							<span style={{ fontWeight: "400" }}>({calculatePercentage(fifthAmount, totalAmount)}%)</span>
						</p>
						<div>{fifthAmount + " " + customLabel}</div>
					</div>
				</section>
			) : null}

			{sixthCaption ? (
				<section className='firstSection'>
					<div className='sixthcolor'></div>
					<div className='firstDetails'>
						<p className='header flex gap-2'>
							{sixthCaption}
							<span style={{ fontWeight: "400" }}>({calculatePercentage(sixthAmount, totalAmount)}%)</span>
						</p>
						<div>{sixthAmount + " " + customLabel}</div>
					</div>
				</section>
			) : null}
		</LabelWrapper>
	);
}

const LabelWrapper = styled.div`
	margin-top: 10px;

	.firstSection {
		display: flex;
		gap: 10px;
		font-size: 14px;
		margin-top: 1rem;

		.firstcolor {
			border-radius: 50%;
			padding: 9px;
			background-color: ${(props) => props.firstcolor};
			align-self: flex-start;
			border-radius: 8px;
		}

		.secondcolor {
			border-radius: 50%;
			padding: 9px;
			background-color: ${(props) => props.secondcolor};
			align-self: flex-start;
			border-radius: 8px;
		}

		.thirdcolor {
			border-radius: 50%;
			padding: 9px;
			background-color: ${(props) => props.thirdcolor};
			align-self: flex-start;
			border-radius: 8px;
		}
		.fourthcolor {
			border-radius: 50%;
			padding: 9px;
			background-color: ${(props) => props.fourthcolor};
			align-self: flex-start;
			border-radius: 8px;
		}
		.fifthcolor {
			border-radius: 50%;
			padding: 9px;
			background-color: ${(props) => props.fifthcolor};
			align-self: flex-start;
			border-radius: 8px;
		}
		.sixthcolor {
			border-radius: 50%;
			padding: 9px;
			background-color: ${(props) => props.sixthcolor};
			align-self: flex-start;
			border-radius: 8px;
		}

		.firstDetails {
			font-size: 0.9rem;
			.header {
				flex-wrap: wrap;
				row-gap: 3px;
				color: #333333;
				font-size: 1rem;
				font-weight: 600;
			}
		}
	}
`;

ChartlabelALT.propTypes = {
	firstColorId: PropTypes.string,
	secondColorId: PropTypes.string,
	thirdColorId: PropTypes.string,
	fourthColorId: PropTypes.string,
	fifthColorId: PropTypes.string,
	sixthColorId: PropTypes.string,
	firstCaption: PropTypes.string,
	secondCaption: PropTypes.string,
	thirdCaption: PropTypes.string,
	fourthCaption: PropTypes.string,
	fifthCaption: PropTypes.string,
	sixthCaption: PropTypes.string,
	firstAmount: PropTypes.number,
	secondAmount: PropTypes.number,
	thirdAmount: PropTypes.number,
	fourthAmount: PropTypes.number,
	fifthAmount: PropTypes.number,
	sixthAmount: PropTypes.number,
	totalAmount: PropTypes.number,
	customLabel: PropTypes.string,
};

export default ChartlabelALT;
